import { useNavigate } from "react-router-dom";
import { auth } from "services";

const Menu = () => {
  let navigate = useNavigate();

  const logout = () => {
    auth.logout();
    location.replace("/login");
  };

  const gotopage = (page) => {
    navigate(page);
  };

  return (
    <ul className="list-unstyled text-dark">
      <li className="my-3">
        <button
          className="fs-4 btn btn-outline-app w-100 text-start mb-1 py-3"
          onClick={() => gotopage("/")}
          data-bs-dismiss="offcanvas"
        >
          <i className="bi bi-book pe-1"></i> Khatabook
        </button>
      </li>
      <li className="my-3">
        <button
          className="fs-4 btn btn-outline-app w-100 text-start mb-1 py-3"
          onClick={() => gotopage("/cashbook")}
          data-bs-dismiss="offcanvas"
        >
          <i className="bi bi-cash-stack pe-1"></i> Cashbook
        </button>
      </li>
      <li className="my-3">
        <button
          className="fs-4 btn btn-outline-app w-100 text-start mb-1 py-3"
          onClick={() => gotopage("/profile")}
          data-bs-dismiss="offcanvas"
        >
          <i className="bi bi-person-circle pe-1"></i> Profile
        </button>
      </li>
      <li className="my-3">
        <button
          className="fs-4 btn btn-outline-app w-100 text-start mb-1 py-3"
          onClick={() => gotopage("/settings")}
          data-bs-dismiss="offcanvas"
        >
          <i className="bi bi-gear pe-1"></i> Settings
        </button>
      </li>
      <li className="my-3">
        <button
          className="fs-4 btn btn-outline-app w-100 text-start mb-1 py-3"
          onClick={() => gotopage("/help")}
          data-bs-dismiss="offcanvas"
        >
          <i className="bi bi-info-circle-fill pe-1"></i> Help & Support
        </button>
      </li>
      <li>
        <div className="row my-3 sticky-bottom-drawer">
          <div className="col-md-12 d-grid">
            <button
              className="fs-4 btn btn-app text-start py-3"
              onClick={logout}
              data-bs-dismiss="offcanvas"
            >
              <i className="bi bi-arrow-left pe-1"></i>
              <span className="fs-3 ms-2">Logout</span>
            </button>
          </div>
        </div>
      </li>
    </ul>
  );
};

export default Menu;